export default __webpack_public_path__ + "static/media/OnDiet.2a411647.png";